module.exports = __webpack_public_path__ + "static/img/rank_39.0768efc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_39.png
// module id = 2xWH
// module chunks = 1